import React, { Fragment } from 'react'
import { Route } from 'react-router-dom'
// import PageTitle from '../../Layout/AppMain/PageTitle';
import { Col, Row } from 'reactstrap'
import AppHeader from '../../Layout/AppHeader'
// import ThemeOptions from '../../Layout/ThemeOptions'
import AppSidebar from '../../Layout/AppSidebar'
import UserSchedule from './UserSchedule'
import UserScheduleList from './UserScheduleList'

class Schedule extends React.Component {
  render() {
    return (
      <Fragment>
        <AppHeader />
        <div className="app-main">
          <AppSidebar />
          <div className="app-main__outer">
            <div className="app-main__inner">
              <Row>
                <Col md="12">
                  <Route
                    path={`${this.props.match.url}/list`}
                    component={UserScheduleList}
                  />
                  <Route
                    path={`${this.props.match.url}/detail/:id`}
                    component={UserSchedule}
                  />
                  {/* <Route
                                        path={`${this.props.match.url}/detail/:id`}
                                        component={DetailUserPoint}
                                    /> */}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default Schedule
